module.exports = __webpack_public_path__ + "static/media/ic_download_allow.a815ddb6.svg";